/**
 * 各検索一覧定義ファイル
 * 概要
 *  各検索一覧で使用する各定義をまとめるファイル
 * 更新履歴
 */

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace searchForm {
  export const CUSTOMER = [
    {
      'display_id': 'customer_name',
      col: 0,
      row: 0,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'customer_class', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      props: {
        label: '顧客区分',
        name: 'customer_class',
        placeholder: '顧客区分'
      },
      col: 4, //Gridで表示する開始コラム数(横)
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'postal_code',
      col: 0,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'prefectures',
      col: 4,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'municipalities',
      col: 8,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'machimura_street_address',
      col: 12,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'building_name',
      col: 0,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'telephone_number',
      col: 4,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    }
  ];
  export const MOCK = [
    {
      'display_id': '顧客名', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_customer_sample',
      props: {
        leftSideInputName: '顧客ID',
        rightSideInputName: '顧客名',
        dialogTitle: '顧客マスタ選択',
        label: '顧客',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': '案件名',
      col: 0,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': '案件ステータス',
      col: 5,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': '営業担当', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 10, //Gridで表示する開始コラム数(横)
      dblookup: 'm_manager',
      props: {
        leftSideInputName: '担当者ID',
        rightSideInputName: '担当者名',
        dialogTitle: '営業担当マスタ選択',
        label: '営業担当',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      row: 1, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
/*    
    {
      'display_id': '与信状況',
      col: 0,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'リース会社', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 5, //Gridで表示する開始コラム数(横)
      dblookup: 'm_leasing_company',
      props: {
        leftSideInputName: 'リース会社ID',
        rightSideInputName: 'リース会社名',
        dialogTitle: 'リース会社マスタ選択',
        label: 'リース会社',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      row: 2, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
*/    
    {
      'display_id': 'サービス種別', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      dblookup: 'm_service',
      props: {
        leftSideInputName: 'サービス種別ID',
        rightSideInputName: 'サービス種別',
        dialogTitle: 'サービス種別マスタ選択',
        label: 'サービス種別',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      col: 0, //Gridで表示する開始コラム数(横)
      row: 2, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': '支払情報', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      props: {
        label: '支払情報',
        name: '支払情報',
        placeholder: '支払情報'
      },
      col: 4, //Gridで表示する開始コラム数(横)
      row: 2, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },    
    {
      'display_id': '商材', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 10, //Gridで表示する開始コラム数(横)
      dblookup: 'm_commodity',
      props: {
        leftSideInputName: '商材ID',
        rightSideInputName: '商材名',
        dialogTitle: '商材マスタ選択',
        label: '商材',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      row: 2, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
/*   
    {
      'display_id': '工事予定日',
      component: 'DatePickerRangeArea',
      col: 0,
      props: {
        nameFrom: '工事予定日',
        nameTo: '工事予定日',
      },
      row: 3,
      sizeX: 4,
      sizeY: 1
    }
*/    
  ];

  export const CustomerListMOCK = [
/*    
    {    
      'display_id': 'customer_name', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_customer_sample',
      props: {
        leftSideInputName: '顧客ID',
        rightSideInputName: '顧客名',
        dialogTitle: '顧客マスタ選択',
        label: '顧客',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1    
    },
*/
    {
      'display_id': 'customer_id',
      col: 0,
      row: 0,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'customer_name',
      col: 4,
      row: 0,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'customer_class', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      props: {
        label: '顧客区分',
        name: 'customer_class',
        placeholder: '顧客区分'
      },
      col: 8, //Gridで表示する開始コラム数(横)
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'postal_code',
      col: 0,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'prefectures',
      col: 4,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'municipalities',
      col: 8,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'machimura_street_address',
      col: 12,
      row: 1,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'building_name',
      col: 0,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'telephone_number',
      col: 4,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'cell_phone_number',
      col: 8,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    }
    /* 検索条件を修正
    ,{
      'display_id': 'department_name',
      col: 12,
      row: 2,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'person_in_charge',
      col: 0,
      row: 3,
      sizeX: 4,
      sizeY: 1  
    },
    {
      'display_id': 'birthday',
      component: 'DatePickerRangeArea',
      props: {
        nameFrom: '生年月日',
        nameTo: '生年月日',
      },
      col: 4,
      row: 3,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'sex', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      props: {
        label: '性別',
        name: 'sex',
        placeholder: '性別'
      },
      col: 8, //Gridで表示する開始コラム数(横)
      row: 3, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'cancellation_date',
      component: 'DatePickerRangeArea',
      props: {
        nameFrom: '解約日',
        nameTo: '解約日',
      },
      col: 12,
      row: 3,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'reason_for_cancellation',
      col: 0,
      row: 4,
      sizeX: 4,
      sizeY: 1  
    }
    */
  ];

  export const MATTERALL = [
    {
      'display_id': 'Status', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      props: {
        label: 'ステータス',
        name: 'Status',
        placeholder: '全ステータス'
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'customer_id', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 4, //Gridで表示する開始コラム数(横)
      dblookup: 'm_customer',
      props: {
        leftSideInputName: 'customer_id',
        masterId: 'id',
        rightSideInputName: 'customer_name',
        dialogTitle: '顧客マスタ選択',
        label: '顧客',
        columns: [
          {text: '見込顧客番号', value: 'customer_id', width:'30%'},
          {text: '顧客名', value: 'customer_name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'department_billing_address_id',
      col: 8, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_billing_address_id',
        label: '顧客部署(請求先)',
        isDisabled: true
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'department_delivery_destination_id',
      col: 12, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_delivery_destination_id',
        label: '顧客部署(納入先)',
        isDisabled: true
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'project_name',
      col: 0,
      row: 1,
      sizeX: 8,
      sizeY: 1
    },
    {
      'display_id': 'order_manager_code',
      component: 'MasterSelectControl',
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'order_manager_code',
        rightSideInputName: 'name',
        masterId:'employee_id',
        dialogTitle: '案件担当者選択',
        columns: [
          {text: '担当者コード', value: 'order_manager_code', width:'30%'},
          {text: '案件担当者', value: 'name', width:'40%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      col: 9,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },

    {
      'display_id': 'manager_id',
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'manager_id',
        rightSideInputName: 'name',
        masterId:'display_employee_id',
        dialogTitle: '担当者選択',
        columns: [
          {text: '社員番号', value: 'display_employee_id', width:'30%'},
          {text: 'ユーザー名', value: 'name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'billing_payment_information',
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'installation_address',
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'payment_information',
      component: 'SelectArea',
      dblookup: 'm_payment_information',
      dataKeyColum: 'service_type_id',
      valueColum: 'display_payment_information_id',
      props: {
        name: 'payment_information'
      },
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    }
  ];

  export const MATTEROA = [
    {
      'display_id': 'Status', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      props: {
        label: 'ステータス',
        name: 'Status',
        placeholder: '全ステータス'
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'customer_id', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 4, //Gridで表示する開始コラム数(横)
      dblookup: 'm_customer',
      props: {
        leftSideInputName: 'customer_id',
        masterId: 'customer_id',
        rightSideInputName: 'customer_name',
        dialogTitle: '顧客マスタ選択',
        label: '顧客',
        columns: [
          {text: '見込顧客番号', value: 'customer_id', width:'30%'},
          {text: '顧客名', value: 'customer_name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'department_billing_address_id',
      col: 8, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_billing_address_id',
        label: '顧客部署(請求先)',
        isDisabled: true
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'department_delivery_destination_id',
      col: 12, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_delivery_destination_id',
        label: '顧客部署(納入先)',
        isDisabled: true,
        isLeftSideInputCodeVisible: false
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'project_name',
      col: 0,
      row: 1,
      sizeX: 8,
      sizeY: 1
    },
    {
      'display_id': 'order_manager_code',
      component: 'MasterSelectControl',
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'order_manager_code',
        rightSideInputName: 'name',
        masterId:'employee_id',
        dialogTitle: '案件担当者選択',
        columns: [
          {text: '担当者コード', value: 'order_manager_code', width:'30%'},
          {text: '案件担当者', value: 'name', width:'40%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      col: 9,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'project_status',
      col: 5,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'billing_payment_information',
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'installation_address',
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'payment_information',
      component: 'SelectArea',
      dblookup: 'm_payment_information',
      dataKeyColum: 'service_type_id',
      valueColum: 'display_payment_information_id',
      props: {
        name: 'payment_information'
      },
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'manager_id',
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'manager_id',
        rightSideInputName: 'name',
        masterId:'employee_id',
        dialogTitle: '担当者選択',
        columns: [
          {text: '社員番号', value: 'display_employee_id', width:'30%'},
          {text: '社員名', value: 'name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'credit_status',
      col: 5,
      row: 3,
      sizeX: 4,
      sizeY: 1
    },

    {
      'display_id': 'true_status',
      col: 5,
      row: 3,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'leasing_company_id',
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_leasing_company',
      props: {
        leftSideInputName: 'leasing_company_id',
        rightSideInputName: 'leasing_company',
        masterId:'id',
        dialogTitle: 'リース会社(本信)選択',
        columns: [],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 3,
      sizeX: 4,
      sizeY: 1
    }
  ];

  export const MATTERFJAPAN = [
    {
      'display_id': 'Status', //対象となるdisplay_id
      component: 'SelectArea', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      props: {
        label: 'ステータス',
        name: 'Status',
        placeholder: '全ステータス'
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'customer_id', //対象となるdisplay_id
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 4, //Gridで表示する開始コラム数(横)
      dblookup: 'm_customer',
      props: {
        leftSideInputName: 'customer_id',
        masterId: 'id',
        rightSideInputName: 'customer_name',
        dialogTitle: '顧客マスタ選択',
        label: '顧客',
        columns: [
          {text: '見込顧客番号', value: 'customer_id', width:'30%'},
          {text: '顧客名', value: 'customer_name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 0, //Gridで表示する行数(縦)
      sizeX: 4, //コンポーネントが占有する横幅
      sizeY: 1
    },
    {
      'display_id': 'department_billing_address_id',
      col: 8, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_billing_address_id',
        label: '顧客部署(請求先)',
        isDisabled: true
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'department_delivery_destination_id',
      col: 12, //Gridで表示する開始コラム数(横)
      component: 'SelectArea',
      dblookup: 'm_customer_department',
      originReference: 'm_customer',
      dataKeyColum: 'customer_id',
      valueColum: 'department_name',
      props: {
        name: 'department_delivery_destination_id',
        label: '顧客部署(納入先)',
        isDisabled: true
      },
      row: 0,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'project_name',
      col: 0,
      row: 1,
      sizeX: 8,
      sizeY: 1
    },
    {
      'display_id': 'order_manager_code',
      component: 'MasterSelectControl',
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'order_manager_code',
        rightSideInputName: 'name',
        masterId:'employee_id',
        dialogTitle: '案件担当者選択',
        columns: [
          {text: '担当者コード', value: 'order_manager_code', width:'30%'},
          {text: '案件担当者', value: 'name', width:'40%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      col: 9,
      row: 1,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'manager_id',
      component: 'MasterSelectControl', //任意で使用するコンポーネント
      col: 0, //Gridで表示する開始コラム数(横)
      dblookup: 'm_employee',
      props: {
        leftSideInputName: 'manager_id',
        rightSideInputName: 'name',
        masterId:'display_employee_id',
        dialogTitle: '担当者選択',
        columns: [
          {text: '社員番号', value: 'display_employee_id', width:'30%'},
          {text: '社員名', value: 'name', width:'70%'}
        ],
        body: [],
        isRightSideInputReadOnly: true,
        isLeftSideInputCodeVisible: false
      },
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'installation_address',
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    },
    {
      'display_id': 'payment_information',
      component: 'SelectArea',
      dblookup: 'm_payment_information',
      dataKeyColum: 'service_type_id',
      valueColum: 'display_payment_information_id',
      props: {
        name: 'payment_information'
      },
      col: 5,
      row: 2,
      sizeX: 4,
      sizeY: 1
    }
  ];

  export const MTEMPBASE = [
    {
      'display_id': 'template_name',
      col: 0,
      row: 0,
      sizeX: 4,
      sizeY: 1
    }
  ];
}

export const searchFormCustomer = searchForm.CUSTOMER;
export const searchFormMock = searchForm.MOCK;
export const CustomerListMock = searchForm.CustomerListMOCK;
//案件情報検索用
export const searchFormMatterALL = searchForm.MATTERALL;
export const searchFormMatterOA = searchForm.MATTEROA;
export const searchFormMatterFJapan = searchForm.MATTERFJAPAN;
//テンプレート検索用
export const searchFormMaterialTemplate = searchForm.MTEMPBASE;
